import { injectReducer } from '../../../store/reducers';
import { injectSagas } from '../../../store/sagas';


export default store => ({
  path : '/profile/change-password',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const ChangePasswordContainer = require('./containers/ChangePassword.js').default;
      const reducer = require('reducers/user').default;
      const sagas = require('sagas/sagas').default;

      injectReducer(store, { key: 'user', reducer });
      injectSagas(store, { key: 'sagas', sagas });

      cb(null, ChangePasswordContainer);
    }, 'changePassword');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/Profile/ChangePassword/index.js